module.exports = __webpack_public_path__ + "static/media/drop-down.f0f701ea.svg";